import MessagingSettings from 'components/ReusableComponents/Messaging/SidebarControls/MessagingSettings'
import { useInternalAdmin } from 'hooks'
import PropTypes from 'prop-types'

import SearchInput from './SearchInput'
import styles from './SidebarControls.module.scss'
import SortDropdown from './SortDropdown/index'

const SidebarControls = ({
  handleSearchChange,
  sortParam,
  handleSortChange,
  filterTimeTresholdInDays,
  setFilterTimeTresholdInDays
}) => {
  const isInternalAdmin = useInternalAdmin()

  return (
    <div className={styles.container}>
      <SearchInput handleChange={handleSearchChange} />
      <SortDropdown sortParam={sortParam} handleSortChange={handleSortChange} />
      {isInternalAdmin && (
        <MessagingSettings
          filterTimeTresholdInDays={filterTimeTresholdInDays}
          setFilterTimeTresholdInDays={setFilterTimeTresholdInDays}
        />
      )}
    </div>
  )
}

SidebarControls.propTypes = {
  handleSearchChange: PropTypes.func.isRequired,
  handleSortChange: PropTypes.func.isRequired,
  sortParam: PropTypes.string.isRequired
}

export default SidebarControls
